import { AnysealClient } from "@anyseal/api-client";

export const adminClient = new AnysealClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  surface: "admin",
  onAuthenticationExpired: () => window.dispatchEvent(new Event("anyseal:admin-auth-expired")),
});
